module.exports = __webpack_public_path__ + "img/Steor-Icons-06.e3891a50.svg";